module.exports = __webpack_public_path__ + "built-mockup.3CKqU8jK.png";